import { useSelectedPositionListSignal } from "../../../../rx/signal/useSelectedPositionListSignal"
import { useSelectedPositionSignal } from "../../../../rx/signal/useSelectedPositionSignal"
import useSelectionModeSignal from "../../../../rx/signal/useSelectionModeSignal"
import type { Nullable } from "../../../../typescript"
import { samePosition } from "../../tile_position_xy/samePosition"
import type { TilePositionXY } from "../../tile_position_xy/TilePositionXY.type"
import type { Engine } from "../Engine.type"
import { SelectionMode } from "./SelectionMode.enum"

export default function updateSelectedPosition (
  engine: Engine,
  position: Nullable<TilePositionXY>,
): void {
  const [getSelectionMode] = useSelectionModeSignal(engine)
  const [getSelectedPositionList, setSelectedPositionList] = useSelectedPositionListSignal(engine)
  const [, setSelectedPosition] = useSelectedPositionSignal(engine)

  const mode = getSelectionMode()
  const current = getSelectedPositionList()
  
  switch (mode) {
    case SelectionMode.SingleSelect:
      setSelectedPosition(position)
      break
      
    case SelectionMode.MultiSelect:
      if (position) {
        if (current.some(pos => samePosition(pos, position))) {
          setSelectedPositionList(current.filter(pos => !samePosition(pos, position)))
        } else {
          setSelectedPositionList([...current, position])
        }
      }
      break
  }
}